// services/carRentalService.js
import api from "./api";
import axios from "axios";

/**
 * ✅ Base serveur (sans /api) — pas d'URL en dur
 * CRA :  REACT_APP_API_BASE_URL=http://localhost:4000
 * Vite:  VITE_API_BASE_URL=http://localhost:4000
 */
const API_BASE =
  process.env.REACT_APP_API_BASE_URL ||
  process.env.VITE_API_BASE_URL ||
  "https://nouzhaback-theta.vercel.app";

/**
 * Ouvre un HTML (formulaire CMI auto-submit) dans la page courante
 */
function openHtmlPage(html) {
  const w = window.open("", "_self"); // ou "_blank"
  w.document.open();
  w.document.write(html);
  w.document.close();
}

const carRentalService = {
  // =========================================================
  // ✅ NOUVEAU : Demande de location (formulaire Séjour/Circuit style)
  // =========================================================
  /**
   * Envoie une demande de location voiture (pas de listing, pas de paiement direct)
   * Backend route: POST /api/reservations/voitures/demande
   */
  createRequest: async (payload) => {
    const response = await api.post("/reservations/voitures/demande", payload);
    return response.data;
  },

  // --- Cars listing & status ---
  getAvailableCars: async (searchParams = {}) => {
    const response = await api.get("/voitures", { params: searchParams });
    return response.data;
  },

  getAllCarsWithStatus: async (searchParams = {}) => {
    const response = await api.get("/voitures/with-status", { params: searchParams });
    return response.data;
  },

  getCarReservedPeriods: async (carId) => {
    const response = await api.get(`/voitures/${carId}/reserved-periods`);
    return response.data;
  },

  // =========================================================
  // ✅ Paiement CMI direct (si tu l'utilises ailleurs)
  // =========================================================
  payWithCMIForCar: async (data) => {
    console.log("voitureId =", data.voitureId);

    // ✅ On utilise toujours la même base que partout
    // api.baseURL = `${API_BASE}/api` (défini dans services/api.js)
    // Donc ici on construit l'URL finale: `${API_BASE}/api/cmi/...`
    const endpoint = `${API_BASE}/api/cmi/voiture/create`;

    // ⚠️ CMI renvoie du HTML => axios + responseType text
    const resp = await axios.post(endpoint, data, {
      headers: { "Content-Type": "application/json", Accept: "text/html" },
      responseType: "text",
      transformResponse: [(r) => r],
    });

    openHtmlPage(resp.data);
    return true;
  },

  // --- (Legacy / Stripe) : conservé si utilisé ailleurs ---
  createReservation: async (reservationData) => {
    try {
      const tempReservationResponse = await api.post(
        "/reservations/voitures/temp",
        reservationData
      );
      const tempReservation = tempReservationResponse.data;

      if (!tempReservation.success || !tempReservation.reservation) {
        throw new Error("Erreur lors de la création de la réservation temporaire");
      }

      const paymentData = {
        reservationId: tempReservation.reservation._id,
        voitureId: reservationData.voiture,
        amount: tempReservation.reservation.prix_total,
        userId: reservationData.utilisateur || null,
        userEmail: reservationData.userEmail || null,
        dateDebut: reservationData.date_debut,
        dateFin: reservationData.date_fin,
        description: `Location de voiture - ${
          tempReservation.reservation.voiture?.marque || ""
        } ${tempReservation.reservation.voiture?.modele || ""}`,
      };

      const stripeResponse = await api.post("/stripe/create-voiture-payment", paymentData);

      if (stripeResponse.data.url) {
        window.location.href = stripeResponse.data.url;
      } else {
        throw new Error("URL de paiement non reçue");
      }

      return stripeResponse.data;
    } catch (error) {
      console.error("Erreur lors de la création de la réservation (Stripe):", error);
      throw error;
    }
  },

  // --- Details & user reservations ---
  getCarById: async (carId) => {
    const response = await api.get(`/voitures/${carId}`);
    return response.data;
  },

  getUserReservations: async () => {
    const response = await api.get("/reservations/voitures/user");
    return response.data;
  },

  cancelReservation: async (reservationId) => {
    const response = await api.delete(`/reservations/voitures/${reservationId}`);
    return response.data;
  },
};

export default carRentalService;
